<template>
  <div class="container">
    <div class="info">
      <h1>Recently viewed</h1>
      <p>Here are the last items you saw.</p>
    </div>
    <div class="product-container">
      <base-product
        v-for="product in recentlyViewed"
        :key="product.productId"
        :img-url="product.productImage"
        :product-title="product.productTitle"
        :product-price="product.productPrice"
        :product-category="product.productCategory"
        :product-id="product.productId"
        :product-color="product.productColor"
      ></base-product>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      recentlyViewed: [],
      user: null,
    };
  },
  mounted() {
    this.recentlyViewed =
      JSON.parse(localStorage.getItem("recentlyViewed")) || [];

      this.user = JSON.parse(localStorage.getItem('user'));

      console.log("User in localStorage:", localStorage.getItem("user"));
      console.log(this.recentlyViewed);
  },
 
};
</script>

<style scoped>
.container {
  padding: 40px;
}
.info {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-left: 40px;
}
h1 {
  color: #000;
  font-family: "Glusp";
  font-size: clamp(1.8rem, 3vw, 2.4rem);
  font-weight: 700;
}
p {
  color: #000;
  font-family: "Mabry Pro";
  font-size: clamp(1.5rem, 3vw, 1.8rem);
  font-weight: 300;
}

@media screen and (min-width: 240px) and (max-width: 480px) {
  .info {
    text-align: center;
    padding: 0;
  }
}

@media screen and (min-width: 481px) and (max-width: 768px) {
  .info {
    text-align: center;
    padding: 0;
  }
}

@media screen and (min-width: 769px) and (max-width: 1024px) {
}

@media screen and (min-width: 1025px) and (max-width: 1200px) {
}

@media screen and (min-width: 1200px) and (max-width: 1900px) {
}
</style>